const getRelativePosition = ({ total, position }) => {
  return +(position * 100 / total).toFixed(4)
}

export default getRelativePosition
